<ng-container *ngIf="tiposSegmento">
    <div class="titulo-pagina">Gerir tipos de segmento</div>
    <div class="table-responsive">
        <table suiteRfbTable tableClass="table table-striped tabela">
            <caption>Tipos de segmento</caption>
            <thead>
                <tr>
                    <th class="text-center">
                        <span>Id</span>
                        <suite-rfb-sort-by [asc]="sortedBy[0]"
                            (onSort)="sortByColuna(0, $event)"></suite-rfb-sort-by>
                    </th>
                    <th class="text-center">
                        <span>Nome do tipo de segmento</span>
                        <suite-rfb-sort-by [asc]="sortedBy[1]"
                            (onSort)="sortByColuna(1, $event)"></suite-rfb-sort-by>
                    </th>
                    <th class="text-center">
                        <span>Sigla</span>
                        <suite-rfb-sort-by [asc]="sortedBy[2]"
                            (onSort)="sortByColuna(2, $event)"></suite-rfb-sort-by>
                    </th>
                    <th class="text-center" colspan="1">
                        Ações
                    </th>
                </tr>
                <tr>
                    <th class="text-center">&nbsp;</th>
                    <th class="text-center">
                        <suite-rfb-filter-by inputClass="form-control filter-by-sm w100" [searchTerms]="estado.filtroNome" (onFilter)="filterByNome($event)"></suite-rfb-filter-by>
                    </th>
                    <th class="text-center">
                        <suite-rfb-filter-by inputClass="form-control filter-by-sm w100" [searchTerms]="estado.filtroSigla" (onFilter)="filterBySigla($event)"></suite-rfb-filter-by>
                    </th>
                    <th class="text-center">&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let tipo of tiposOriginaisOrdenados | currentPage:currentPage">
                    <td class="text-center">
                        {{ tipo.idTipoSegmento }}
                    </td>
                    <td class="text-center">
                        {{ tipo.nomeTipoSegmento }}
                    </td>
                    <td class="text-center">
                        {{ tipo.siglaTipoSegmento }}
                    </td>
                    <td class="text-center">
                        <a>
                            <span title="Visualizar tipo de segmento" container="body" (click)="visualizarTipoSegmento(tipo)">
                                <span class="material-icons icon-24">visibility</span>
                            </span>
                        </a>
                        &nbsp;
                        <a>
                            <span title="Editar tipo de segmento" container="body" (click)="editarTipoSegmento(tipo)">
                                <span class="material-icons icon-24">edit</span>
                            </span>
                        </a>
                        &nbsp;
                        <suite-rfb-confirmation-link
                            *ngIf="tipo.idTipoSegmento !== 0"
                            popupTitle="Excluir tipo de segmento" (accept)="excluirTipoSegmento(tipo)"
                            question="O tipo de segmento '{{tipo.nomeTipoSegmento}}' será excluído! Confirma a operação?">
                            
                            <span title="Excluir tipo de segmento" container="body">
                                <span class="material-icons icon-24">delete</span>
                            </span>
                        </suite-rfb-confirmation-link>
                        <span *ngIf="tipo.idTipoSegmento === 0" title="Não é possível excluir o tipo de segmento" container="body">
                            <span class="material-icons icon-24 botao-inativo">delete</span>
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="tabela-links">
        <suite-rfb-pagination [(itemAmount)]="tiposOriginaisOrdenados.length" [(pageSize)]="pageSize" [(page)]="currentPage"
            (pageChange)="subirParaTopoPagina()">
        </suite-rfb-pagination>
    </div>
    <hr>
    <div class="row">
        <div class="col-sm-4">
            <div class="form-group">
                <button type="button" class="btn btn-primary" (click)="incluirNovoTipoSegmento()">Incluir tipo de segmento</button>
            </div>
        </div>
    </div>
</ng-container>

<div class="modal-area-morta" *ngIf="exibirModalEstiloSegmento"
        (keypress)="$event.stopPropagation()"
        (keyup)="$event.stopPropagation()"
        (keydown)="$event.stopPropagation()"
        role="dialog">
    <div class="modal-area-util" cdkDrag>
        <div class="modal-content">
            <div class="modal-header" cdkDragHandle>
                <h4 class="modal-title">
                    {{ tipoEdicao.titulo }}
                </h4>
            </div>
            <div class="modal-body">
                <form #form="ngForm">
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group" [suiteRfbHasError]="nomeCtrl">
                                <label for="nome" class="control-label obrigatorio">Nome do tipo de segmento</label>
                                <input type="text" #nomeInput #nomeCtrl="ngModel" class="form-control" name="nome" [(ngModel)]="tipoSegmento.nomeTipoSegmento"
                                    maxlength="30" [disabled]="readonly || tipoSegmento.idTipoSegmento === 0" [required]="true">
                                <suite-rfb-local-messages [control]="nomeCtrl"></suite-rfb-local-messages>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group" [suiteRfbHasError]="siglaCtrl">
                                <label for="nome" class="control-label obrigatorio">Sigla do tipo de segmento</label>
                                <input type="text" #siglaInput #siglaCtrl="ngModel" class="form-control" name="sigla" [(ngModel)]="tipoSegmento.siglaTipoSegmento"
                                    maxlength="30" [disabled]="tipoEdicao.isEdicaoTipoSegmento()" [required]="true">
                                <suite-rfb-local-messages [control]="siglaCtrl"></suite-rfb-local-messages>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <app-painel-estilo-segmento
                                [tipoSegmento]="tipoSegmento"
                                [tipoSegmentoGlobal]="tipoSegmentoGlobal"
                                [readonly]="readonly"
                                [modoTipoSegmento]="true"
                                (aplicarEstiloSegmento)="salvarTipoSegmento($event)">
                            </app-painel-estilo-segmento>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
